module.exports = __webpack_public_path__ + "static/feature_bg4-399db8b203bcd8c6f9bc74772aa46f75.png";